module.exports = __webpack_public_path__ + "media/icons/fb-0de70a0a.svg";